module.exports = "<list-plugin [(options)]=\"options\"></list-plugin>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/donna-core/src/app/addresses/plugins/address-relation/address-relation.plugin.html
// module id = ./libs/donna-core/src/app/addresses/plugins/address-relation/address-relation.plugin.html
// module chunks = main